import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { baseURL } from '@/config/api.config'
import { toCamelcase, toSnakecase } from '@/utils/fieldStyle'
import { Notify, Dialog } from 'vant'
import { X_TOKEN } from '@/data/Constant'
import { clearToken } from '@/api'

const instance = axios.create({
  baseURL,
  timeout: 20000
})

instance.interceptors.request.use(function (config) {
  Vue.ls.get(X_TOKEN) && (config.headers['Token'] = Vue.ls.get(X_TOKEN))
  config.data = toSnakecase(config.data)
  config.params = toSnakecase(config.params)
  return config
}, function (error) {
  return Promise.reject(error)
})
instance.interceptors.response.use(function (response) {
  return toCamelcase(response.data)
}, function (error) {
  if (error.code === 'ECONNABORTED') {
    Dialog.confirm({
      title: '网络超时',
      message: '当前网络不佳，建议刷新重试',
      confirmButtonText: '刷新',
      cancelButtonText: '联系客服'
    })
      .then(() => {
        // on confirm
        window.location.reload()
      })
      .catch(() => {
        // on cancel
        store.dispatch('setServiceShow', true)
      })
    return Promise.reject(error)
  }
  // 机构被禁的情况下退出登录
  if (code === 'organization_forbidden') {
    clearToken()
    Vue.router.replace({
      name: 'login'
    })
  }
  const { code = '', message } = error.response && error.response.data || {}
  Notify({
    type: 'danger',
    message: message || '请求出错：请刷新重试或联系平台'
  })

  return Promise.reject(error)
})

export default instance
